"use client";

import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import Image from "next/image";
import { Breadcrumb } from "../breadcrumb";
import { Heading1 } from "../typography";

export const CaseStudiesHero = () => {
  useSectionNavTheme({
    trigger: `#case-studies-hero`,
    end: () => `+=100%`,
    isDark: false,
  });

  useGSAP(() => {
    const tl = gsap.timeline();

    const splitTitle = new SplitText(".case-studies-title", {
      type: "words,chars",
    });

    tl.from(splitTitle.chars, {
      opacity: 0,
      y: 20,
      duration: 0.8,
      stagger: 0.02,
      ease: "power2.out",
    }).from(
      ".case-studies-subtitle",
      {
        opacity: 0,
        y: 30,
        duration: 0.6,
        ease: "power2.out",
      },
      "-=0.4"
    );
  });

  return (
    <section
      id="case-studies-hero"
      className="relative h-[600px] lg:h-[700px] bg-haizea-green dark:bg-haizea-dark overflow-hidden"
    >
      <Image
        src="/images/logo-icon-white.webp"
        alt="River Basin"
        className="absolute -left-[100px] -top-[100px] opacity-10 w-[600px] h-[600px] max-w-none select-none object-cover"
        data-speed="0.5"
        width={600}
        height={600}
      />
      <div
        className="absolute inset-0 bg-gradient-to-br via-haizea-dark/60 from-transparent to-haizea-green"
        data-speed="0.05"
      ></div>
      <div className="relative z-20 py-20 lg:py-32 flex flex-col">
        <div className="container relative z-20">
          <Breadcrumb
            items={[{ label: "Home", href: "/" }, { label: "Case Studies" }]}
            className="my-8 lg:mt-0"
          />
        </div>
        <div className="container relative flex-1 flex items-center">
          <div className="max-w-4xl mx-auto text-center">
            <Heading1 className="case-studies-title banner-text drop-shadow-4xl text-white mb-6">
              Our Case Studies
            </Heading1>

            <p className="case-studies-subtitle text-lg text-slate-50 md:text-2xl lg:text-3xl drop-shadow-4xl leading-snug max-w-[900px] mx-auto font-light">
              Discover how our satellite monitoring technology is transforming
              industries and delivering measurable results for organisations
              worldwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
